module.exports = __webpack_public_path__ + "media/images/errors/404-8b0e10f17d77edb9a7962dfaad8b3495.svg";